var _rect, _rect2, _circle, _rect3, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPtFlag = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 356.18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 170.67,
    height: 356.18,
    fill: "#006600"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    width: 341.33,
    height: 356.18,
    fill: "#ff0000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170.67,
    cy: 178.09,
    r: 67,
    fill: "#ffcc00",
    stroke: "#000",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 138,
    width: 41,
    height: 80,
    rx: 5,
    fill: "#ffffff",
    stroke: "#000",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.7,
    cy: 152,
    r: 6,
    fill: "#003399"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 178,
    r: 6,
    fill: "#003399"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 178,
    r: 6,
    fill: "#003399"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 204,
    r: 6,
    fill: "#003399"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.4,
    cy: 204,
    r: 6,
    fill: "#003399"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPtFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PT-flag.81b93d601245fb5259b2dd0b81f82994.svg";